<template>
  <div
    class="flex w-full vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vs-card class="page-bg-color p-8">
        <div class="heading">
          <h2 class="mb-6">{{ $t("labels.head_admin_password") }}</h2>
        </div>
        <form @submit.prevent="changePassword()" autocomplete="off">
          <vs-row
            class="flex w-full vx-row no-gutter items-center justify-center"
          >
            <div class="vx-col sm:w-full md:w-full lg:w-1/1 d-theme-dark-bg">
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <div class="password-field">
                    <vs-input
                      :type="passwordfieldtype"
                      class="w-full password-field"
                      name="old_password"
                      maxlength="20"
                      :label-placeholder="$t('labels.old_password')"
                      icon-pack="feather"
                      icon="icon-lock"
                      icon-no-border
                      label="Name"
                      v-model="old_password"
                      v-validate="'required'"
                    />
                    <button
                      tabindex="-1"
                      type="button"
                      @click="switchVisibility('passwordfieldtype')"
                      :class="
                        passwordfieldtype == 'password' ? 'eyeclose' : 'eyeopen'
                      "
                      style="cursor: pointer"
                    ></button>
                  </div>
                  <span class="text-danger text-sm">{{
                    errors.first("old_password")
                  }}</span>
                </div>
              </div>
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <div class="password-field">
                    <vs-input
                      :type="newpasswordfieldtype"
                      class="w-full password-field"
                      name="password"
                      icon-pack="feather"
                      icon="icon-lock"
                      icon-no-border
                      :label-placeholder="$t('labels.new_password')"
                      v-model="new_password"
                      ref="password"
                      maxlength="20"
                      v-validate="{
                        required: true,
                        min: 8,
                        max: 20,
                        regex:
                          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
                      }"
                    />
                    <button
                      tabindex="-1"
                      type="button"
                      @click="switchVisibility('newpasswordfieldtype')"
                      :class="
                        newpasswordfieldtype == 'password'
                          ? 'eyeclose'
                          : 'eyeopen'
                      "
                      style="cursor: pointer"
                    ></button>
                  </div>
                  <span class="text-danger text-sm">{{
                    errors.first("password")
                  }}</span>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col w-full">
                  <div class="password-field">
                    <vs-input
                      :type="oldpasswordfieldtype"
                      class="w-full password-field"
                      name="password_confirmation"
                      icon-pack="feather"
                      icon="icon-lock"
                      maxlength="20"
                      icon-no-border
                      :label-placeholder="$t('labels.confirm_password')"
                      v-model="confirm_password"
                      v-validate="'required|confirmed:password'"
                    />
                    <button
                      tabindex="-1"
                      type="button"
                      @click="switchVisibility('oldpasswordfieldtype')"
                      :class="
                        oldpasswordfieldtype == 'password'
                          ? 'eyeclose'
                          : 'eyeopen'
                      "
                      style="cursor: pointer"
                    ></button>
                  </div>
                  <span class="text-danger text-sm">{{
                    errors.first("password_confirmation")
                  }}</span>
                </div>
              </div>

              <div class="vx-row">
                <div class="vx-col w-full">
                  <vs-button
                    color="dark"
                    type="filled"
                    class="
                      vs-component vs-button
                      mr-3
                      px-4
                      w-full
                      md:w-auto
                      mt-3
                      mb-8
                      md:mt-0 md:mb-0
                    "
                    @click.prevent="back()"
                    >{{ $t("labels.back") }}</vs-button
                  >

                  <vs-button
                    tabindex="-1"
                    class="
                      vs-component vs-button
                      px-4
                      w-full
                      md:w-auto
                      mr-3
                      mb-2
                      md:mt-0 md:mb-0
                      vs-button-primary vs-button-filled
                    "
                    :disabled="button_loading"
                    id="change-password"
                    button="submit"
                    >{{ $t("labels.save_password") }}</vs-button
                  >
                </div>
              </div>
            </div>
          </vs-row>
        </form>
      </vs-card>
    </div>
  </div>
</template>
<script>
import { Validator } from "vee-validate";
import axios from "axios";
export default {
  data() {
    return {
      old_password: null,
      new_password: null,
      confirm_password: null,
      token: null,
      passwordfieldtype: "password",
      newpasswordfieldtype: "password",
      oldpasswordfieldtype: "password",
    };
  },

  mounted() {
    this.setValidationMessage();
  },
  methods: {
    changePassword() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.button_loader(true, "#change-password");
          let input = {
            token: this.token,
            old_password: this.old_password,
            password: this.new_password,
            password_confirmation: this.confirm_password,
          };
          axios
            .post("user/changePassword", input)
            .then((response) => {
              this.button_loader(false, "#change-password");
              let data = response.data;
              this.$vs.notify({
                text: data.message,
                color: "success",
                position: "top-right",
              });
              localStorage.removeItem("authToken");
              localStorage.removeItem("user");
              localStorage.removeItem("auth");
              this.$router.push({
                name: "login",
              });
            })
            .catch((e) => {
              this.showError(e, "#change-password");
            });
        }
      });
    },
    back() {
      history.back();
    },
    switchVisibility(field) {
      if (field == "passwordfieldtype") {
        this.passwordfieldtype =
          this.passwordfieldtype === "password" ? "text" : "password";
      }
      if (field == "newpasswordfieldtype") {
        this.newpasswordfieldtype =
          this.newpasswordfieldtype === "password" ? "text" : "password";
      }
      if (field == "oldpasswordfieldtype") {
        this.oldpasswordfieldtype =
          this.oldpasswordfieldtype === "password" ? "text" : "password";
      }
    },
  },
};
</script>

        